import {z as zod} from "zod";
import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {FitmentMasterNodeStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/flexibleFitmentEngineWorkspaceCapability/domain/FlexibleFitmentEngine";

export type FitmentMasterNode = {
    createdAt: Iso8601DateTime;
    displayName: string;
    id: Uuid;
    nodeType: string;
    parentId: Uuid | null;
    revisionId: Uuid;
    status: FitmentMasterNodeStatus;
    updatedAt: Iso8601DateTime;
    attributes?: Record<string, unknown> | null;
};

export const fitmentMasterNodeValidator: zod.ZodType<FitmentMasterNode> = zod.object({
    attributes: zod.record(zod.string(), zod.unknown()).nullable().optional(),
    createdAt: iso8601DateTimeZodValidator,
    displayName: zod.string(),
    id: uuidZodValidator,
    nodeType: zod.string(),
    parentId: uuidZodValidator.nullable(),
    revisionId: uuidZodValidator,
    status: zod.enum(FitmentMasterNodeStatus),
    updatedAt: iso8601DateTimeZodValidator,
});
